import { Store } from 'vuex';
import UserInfo from '@/core/userinfo';

let userInfo: UserInfo | null = null;

export function setUserInfo(info: UserInfo): void {
    userInfo = info;
}

export function getUserInfo(): UserInfo | null {
    return userInfo;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const userInfoPlugin = () => (store: Store<any>) => {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    store.subscribe(() => {
    });
};

export default userInfoPlugin;
